/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2022
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Dreapta-la-stânga",
		"timeZoneID": "Fus orar",
		"skin": "Stil",
		"metricsFileImportTask": "Import nou din fişiere",
		"displayMode": "Vizualizare implicită",
		"credentialRenewed": "Acreditările dvs. au fost reînnoite cu valorile dumneavoastră curente pentru ID-ul de utilizator şi parolă.",
		"productLocale": "Limbă produs",
		"toggleDisabled": "dezactivată",
		"credentialChange": "Reînnoire",
		"log_level_Debug": "Depanare",
		"confirmNewPassword": "Confirmare parolă nouă",
		"unsavedViewMsg2": "Modificările dumneavoastră vor fi pierdute dacă nu le salvaţi în prealabil.",
		"supportPortalErrorMessage": "Încercaţi din nou.  Dacă problema persistă, contactaţi administratorul.",
		"legalText": "Materiale licenţiate - Proprietatea IBM Corp. © Copyright IBM Corporation şi alţii 2005,  %{year}. IBM, emblema IBM, ibm.com şi Cognos sunt mărci comerciale sau mărci comerciale înregistrate deţinute de International Business Machines Corp., înregistrate în multe jurisdicţii din întreaga lume. Lista curentă cu mărcile comerciale IBM este disponibilă pe Web, la www.ibm.com/legal/copytrade.shtml. Acest Program este licenţiat în baza termenilor din acordul de licenţă care însoţeşte Programul. Acest acord de licenţă se poate afla într-un folder al directorului Programului sau într-o bibliotecă, cu numele \"License\" sau \"Non_IBM_License\" dacă este aplicabil, sau poate fi furnizat ca acord de licenţă tipărit. Vă rugăm să citiţi cu atenţie acordul înainte de a utiliza Programul. Prin utilizarea Programului, vă daţi acordul cu privire la aceşti termeni.",
		"groupsAndRoles": "Grupuri şi roluri",
		"metricsMaintenanceTask": "Întreţinere nouă",
		"email": "E-mail",
		"contextual": "Contextual",
		"resetHome": "Resetare la valoarea implicită",
		"ltr": "Stânga-la-dreapta",
		"credentials": "Acreditări",
		"logging_congfig_title": "Jurnalizare",
		"changePasswordTitle": "Modificare parola mea",
		"format": "Format raport",
		"showUnread": "Afişare necitite",
		"AILearning_active": "Învăţarea AI este activată:",
		"docsErrorMessage": "Încercaţi din nou.  Dacă problema persistă, contactaţi administratorul.",
		"toggleEnabled": "activată",
		"homeSetError": "A apărut o eroare la setarea paginii implicite Acasă, încercaţi să închideţi şi să redeschideţi această vizualizare.",
		"passwordChange": "Modificaţi-vă parola",
		"profile": "Profil",
		"pdfRestricted": "PDF (Restricţionat)",
		"drillThrough": "Definiţii drill-through",
		"homeSet": "Pagina dumneavoastră Acasă a fost setată cu succes",
		"regionalOptions": "Opţiuni regionale",
		"myPreferences": "Preferinţele mele",
		"defaultHome": "Implicit",
		"version": "Versiune",
		"controller": "Controller",
		"manage": "Gestionare",
		"biDirectionalFeaturesEnabled": "Suport pentru limbă bidirecţională",
		"newFeaturesErrorTitle": "Legătura la Caracteristici noi nu a funcţionat",
		"passwordMatch": "Potrivire parolă",
		"updateProfileAndsettings": "Actualizare profil şi setări",
		"dashboardConsole": "Spaţiu de lucru",
		"legacyAppsSlideoutLabel": "Aplicaţii moştenite disponibile",
		"logging_config_description": "Jurnalizare este utilizată pentru depanare. Consultaţi-vă administratorul pentru asistenţă la setare.",
		"confirmDeletion": "Confirmare ştergere",
		"signInButtonText": "Logare",
		"dataSourceCredentials": "Acreditări servere de date",
		"AILearningConfigurationSlideoutAllyLabel": "Configuraţie învăţare AI",
		"loadingSettings": "Încărcare setări",
		"spreadsheetMLRestricted": "Excel (Restricţionat)",
		"manageAILearning": "Învăţare AI",
		"xlsxDataRestricted": "Excel Data (Restricţionat)",
		"advanced": "Opţiuni avansate",
		"ok": "OK",
		"changeEmail": "Modificare",
		"showHints": "Afişare indicaţii",
		"general": "General",
		"xlsxData": "Date Excel",
		"newPassword": "Parolă nouă",
		"hideAll": "Ascundere tot",
		"confirmPassword": "Confirmaţi parola",
		"AILearning_config_description": "Îmbunătăţiţi recomandările in-product permiţând Cognos Analytics să înveţe despre utilizarea dumneavoastră.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "Legătura la Support Portal nu a funcţionat",
		"log_level_Warn": "Avertisment",
		"contentSettings": "Setări de conţinut",
		"setHomeButton": "Stabilire",
		"myCapabilities": "Aptitudinile mele",
		"homePage": "Pagina Acasă",
		"helpErrorMessage": "Încercaţi din nou.  Dacă problema persistă, contactaţi administratorul.",
		"loadingProfile": "Încărcare profil",
		"portal": "Portal",
		"metricsPackage": "Pachet nou",
		"myCredentials": "Acreditările mele",
		"myApiKeys": "Cheile mele de API",
		"credentialCreate": "Creare",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "Nu se poate actualiza parola",
		"showHiddenObjects": "Afişare intrări ascunse",
		"csv": "CSV",
		"docsErrorTitle": "Legătura la Documentaţie nu a funcţionat",
		"log_level_Error": "Eroare",
		"wrongPassword": "Imposibil de autentificat",
		"productName": "IBM Cognos Analytics with Watson %{version}",
		"log_level_Info": "Informaţii",
		"welcomeBanner": "Banner de întâmpinare",
		"helpErrorTitle": "Legătura la Ajutor nu a funcţionat",
		"contentLocale": "Limbă conţinut",
		"pdf": "PDF",
		"oldPassword": "Parolă veche",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Caracteristici de accesibilitate",
		"manageLogging": "Jurnalizare",
		"loggingConfigurationSlideoutA11yLabel": "Jurnalizare configuraţie",
		"communityErrorTitle": "Legătura la Comunitate nu a funcţionat",
		"companionApps": "Aplicaţii Companion",
		"setHomeLabel": "Setare acasă ca (vizualizare curentă)",
		"metricsExportTask": "Export nou",
		"csvRestricted": "CSV (Restricţionat)",
		"newFeaturesErrorMessage": "Încercaţi din nou.  Dacă problema persistă, contactaţi administratorul.",
		"contributor": "Contributor",
		"showAll": "Afişare tot",
		"logging_active": "Jurnalizare este pe:",
		"html": "HTML",
		"profileAndSettings": "Profil şi setări",
		"baseTextDirection": "Direcţie de bază pentru text",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Parolă",
		"invalidEmail": "Introduceţi o adresă de e-mail validă",
		"credentialCreateSuccess": "V-aţi creat acreditările cu succes",
		"settings": "Setări",
		"restrictedFormatSelected": "Nu aveţi aptitudinea să rulaţi rapoarte în acest format, dar puteţi accesa rapoarte care sunt salvate în acest format.",
		"usageDataDeletionConfirmation": "Prin ştergerea datelor de utilizare, se resetează învăţarea AI.  Sunteţi sigur că vreţi să ştergeţi datele de utilizare?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Vizualizare detalii",
		"deleteUsageData": "Ştergere date de utilizare:",
		"showPassword": "Afişare parolă",
		"AILearning_config_title": "Învăţare AI",
		"myPreferencesSlideoutLabel": "Profil şi setări",
		"passWordChangeSuccess": "V-aţi schimbat parola cu succes",
		"logging_level": "Nivel de jurnalizare:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Încercaţi din nou.  Dacă problema persistă, contactaţi administratorul.",
		"cancel": "Anulare",
		"shareSetError": "Această acţiune nu poate fi realizată înainte de a închide şi a redeschide această vizualizare.",
		"passwordNotMatch": "Hopa, parola nu se potriveşte",
		"xml": "XML",
		"xmlRestricted": "XML (Restricţionat)",
		"openMenu": "Deschidere meniu",
		"closeMenu": 'Închidere meniu'
});